import { createContext } from 'react'
import type { TrackController } from './trackController'

export const TrackControllerContext = createContext<TrackController | null>(null)